import { createAction, props } from '@ngrx/store';
// import { Hospital } from 'src/models/module-wise/user/patient';

// TODO: Add Interface

export const paginateHospitals = createAction(
  '[ HOSPITAL ] Paginating'
);

export const loadHospitals = createAction(
  '[ HOSPITAL ] Load Hospital',
  props<{ payload: any[], totalDocuments: number }>()
);

export const editHospital = createAction(
  '[ HOSPITAL ] Edit Hospital',
  props<{ payload: any | { status: string, _id: string } }>()
);

export const removeHospitals = createAction(
  '[ HOSPITAL ] Delete Hospital',
  props<{ payload: string[] }>()
);

export const removeAllHospitals = createAction(
  '[ HOSPITAL ] Remove All Hospital'
);
